import React from "react";
import { Check, X } from "lucide-react";

import RevenueOpportunityStatusTableActions from "components/RevenueOpportunityStatusTable/RevenueOpportunityStatusTableActions";

const BooleanFlagCell = ({ value }) =>
  value ? (
    <Check className="tw:size-4 tw:text-[#24B388]" aria-label="Yes" />
  ) : (
    <X className="tw:size-4 tw:text-destructive" aria-label="No" />
  );

export const getRevenueOpportunityStatusTableColumns = () => {
  return [
    {
      id: "Opportunity Status ID",
      accessorKey: "id",
      header: "Opportunity Status ID",
      size: 180,
      enableSorting: true,
      cell: info => info.getValue(),
    },
    {
      id: "Name",
      accessorKey: "name",
      header: "Name",
      size: 300,
      enableSorting: true,
      cell: info => info.getValue(),
    },
    {
      id: "Description",
      accessorKey: "description",
      header: "Description",
      size: 400,
      enableSorting: false,
      cell: info => info.getValue(),
    },
    {
      id: "Closed",
      accessorKey: "is_closed",
      header: "Closed",
      size: 100,
      enableSorting: false,
      cell: info => <BooleanFlagCell value={info.getValue()} />,
    },
    {
      id: "Won",
      accessorKey: "is_won",
      header: "Won",
      size: 100,
      enableSorting: false,
      cell: info => <BooleanFlagCell value={info.getValue()} />,
    },
    {
      id: "Actions",
      accessorKey: "actions",
      header: "Actions",
      size: 100,
      enableSorting: false,
      enableResizing: false,
      cell: ({ row }) => (
        <RevenueOpportunityStatusTableActions original={row.original} />
      ),
    },
  ];
};
